import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'devextreme-react/button'
import axios from 'axios'

export default function Process() {
	const [navigationItems, setNavigationItems] = useState({})
	const [exportItems, setExportItems] = useState({})

	const navigate = useNavigate()
	const handleClick = (process: string) => navigate(`/imports?process=${process}`)

	const handleExportClick = (process: string) => {
		navigate(`/export-config/${process}`)
	}

	useEffect(() => {
		document.title = 'Fiber :: Processes'
	}, [])

	useEffect(() => {
		axios
			.get(`${API_FIBER_URL}/processes`)
			.then(response => response.data)
			.then(data => {
				setNavigationItems(data.processes)
				if (data.exports) {
					setExportItems(data.exports)
				}
			})
	}, [])

	function Buttons() {
		return (
			<div style={{ display: 'flex', gap: '40px', width: '100%', flexDirection: 'column' }}>
				<div className={'content-block gridView'}>
					{Object.entries(navigationItems).map(([process, text]) => (
						<div key={process}>
							<Button className={'modelCard'} text={`${text}`} onClick={() => handleClick(process)} />
						</div>
					))}
				</div>
				<div className={'content-block gridView'}>
					{Object.entries(exportItems).map(([process, text]) => (
						<div key={process}>
							<Button
								className={'modelCard'}
								text={`${text}`}
								icon="exportxlsx"
								onClick={() => handleExportClick(process)}
							/>
						</div>
					))}
				</div>
			</div>
		)
	}

	return (
		<React.Fragment>
			<h2 className={'content-block'}>
				<span className={'dx-icon-upload'} style={{ fontSize: '24px' }}></span> Processes
			</h2>
			{(Object.keys(navigationItems).length > 0 || Object.keys(exportItems).length > 0) && <Buttons />}
		</React.Fragment>
	)
}
